import { login } from './login';
import { loginOrRegister } from './loginOrRegister';
import { getPayments } from './getPayments';
import { getEmailStatus } from './getEmailStatus';
import { resendEmailVerification } from './resendEmailVerification';
import { consumeVerificationCode } from './consumeVerificationCode';
import { getMedcards } from './getMedcards';
import { removePayment } from './removePayment';
import { updateUserProfile } from './updateUserProfile';
import { addPayment } from './addPayment';
import * as Client from './client';
import { updatePayment } from './updatePayment';

export const AccountAPI = {
    login,
    loginOrRegister,
    getPayments,
    getEmailStatus,
    removePayment,
    resendEmailVerification,
    consumeVerificationCode,
    getMedcards,
    updateUserProfile,
    addPayment,
    Client,
    updatePayment,
};
